<template>
  <select
      :value="value"
      @input="onInput"
      @change="onChange"
      @blur="onBlur"
      v-bind="{...$props, ...inputAttributes}"
  >
    <slot></slot>
    <option v-for="option in options" :value="option.value" :selected="option.value === value">{{ option.label }}</option>
  </select>
</template>

<script>
import { isDefined } from '@/utilities';

export default {
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      }
    },
    type: {
      type: String,
      default: 'text'
    },
    id: {
      type: String,
    },
    placeholder: {
      type: String
    },
    value: {
      type: [Number, String]
    }
  },
  computed: {
    inputAttributes() {
      return {...this.$attrs, ...{class: isDefined(this.$attrs.class) ? this.$attrs.class : ''}}
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    },
    onChange(event) {
      this.$emit('change', event.target.value);
    },
    onBlur(event) {
      this.$emit('blur', event);
    }
  }
}
</script>
